import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, filter, size, page }) =>
    present(
      repository
        .getProjectTimeSheet(project, filter, size, page)
        .then((timeSheet) => ({ project, timeSheet, filter, size, page }))
        .catch(() => Promise.reject({ project, filter, size, page })),
    );
}

export type { Interactor };

export { createInteractor };
